//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular, {ISCEService, IWindowService} from 'angular';
import showroomMobilePreviewButtonsTemplate from '@legacy-components/common/universal-image-actions/showroom-mobile-preview-buttons.html';

class ShowroomMobilePreviewButtons {
  public showroomExternalDesktopPreviewUrl: string;
  public trackingCategory: string;
  public trackingAction: string;
  public isDesktopPassthroughEnabled: boolean;

  constructor(
        private $sce: ISCEService,
        private $window: IWindowService,
        private ShowroomService,
        private TrackingService,
    ) { }

  public openShowroomDesktopPreview() {
    if (this.isDesktopPassthroughEnabled) {
      return;
    }

    this.TrackingService.recordEvent(
            this.trackingCategory,
            this.trackingAction,
            'DesktopPreview',
        );

    if (this.showroomExternalDesktopPreviewUrl) {
      this.$window.open(this.showroomExternalDesktopPreviewUrl, '_blank');
    }
  }

  public $onInit() {
    this.ShowroomService.getCurrentConfigStatusObservable().subscribe((state) => {
      this.showroomExternalDesktopPreviewUrl = this.$sce.trustAsResourceUrl(state.externalDesktopPreviewUrl);

      if (state.loaded) {
        this.trackingCategory = this.ShowroomService.getTrackingCategory();
        this.trackingAction = this.ShowroomService.getTrackingAction();

        this.isDesktopPassthroughEnabled = state.passthrough && !state.passthrough.showDesktopExperience;
      }
    });
  }
}

angular.module('uia').component('showroomMobilePreviewButtons', {
  template: showroomMobilePreviewButtonsTemplate,
  controller: [
    '$sce',
    '$window',
    'ShowroomService',
    'TrackingService',
    ShowroomMobilePreviewButtons,
  ],
});
